import { useAsyncData, useRequestURL, useRoute, useRouteParams } from '#imports'

import type { _Block } from '@backmarket/http-api/src/api-specs-content/models/block'
import type { CategoryTreeProps } from '@backmarket/http-api/src/api-specs-content/models/category-tree'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { transformHref } from '../../../cms/helpers/link/transformHref'
import { CMS } from '../../../cms/routes-names'

function formatCategoryTreeLinks(
  categoryTree: _Block<'CategoryTree'>,
  currentUrl: URL,
): CategoryTreeProps {
  return {
    ...categoryTree.props,
    categoryTree: categoryTree?.props?.categoryTree?.map((ce) => {
      return {
        ...ce,
        link: transformHref({
          href: ce.link.href || '',
          currentUrl,
        }),
        subCategories: ce.subCategories.map((sc) => {
          return {
            ...sc,
            link: transformHref({
              href: sc.link.href || '',
              currentUrl,
            }),
          }
        }),
      }
    }),
  }
}

export async function useFetchContentHub() {
  const $httpFetch = useHttpFetch()
  const routeParams = useRouteParams()
  const route = useRoute()
  const currentUrl = useRequestURL()

  const pageCategory =
    route.name === CMS.ARTICLE_ROOT_HUB ? 'content' : routeParams.pageCategory

  const { data, error } = await useAsyncData(
    getAsyncDataKey('cms-article-hub', { pageCategory }),
    () => {
      return $httpFetch('/content/page/article-category/:pageCategory', {
        pathParams: { pageCategory },
      })
    },
  )

  if (data.value) {
    data.value.categoryTree.props = formatCategoryTreeLinks(
      data.value.categoryTree,
      currentUrl,
    )

    if (typeof data.value.displayBreadcrumb !== 'boolean') {
      data.value.displayBreadcrumb = true
    }
  }

  return { data, error }
}
